import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {LanguageListStore} from '../LanguageListStore';

@observer
export class DeleteLanguageControls extends React.Component<{ store: LanguageListStore }> {
  render() {
    const {store} = this.props;

    if (store.deleteLanguage === null)
      return null;

    const deleteLanguage = store.deleteLanguage;
    const isFailure = deleteLanguage.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Saving" state={deleteLanguage.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDelete(deleteLanguage.languageId)}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
